import { urls } from './../../config';
import authFetch from './../../utils/authFetch';
import uploadFetchAmazon from './../../utils/uploadFetchAmazon';
import shortid from 'shortid';

import { notificationSetMessageRead } from './../notification/actions';

export const ORDERS_ADD_LIST = 'ORDERS_ADD_LIST';
export const ORDERS_HIDE_IN_LISTS = 'ORDERS_HIDE_IN_LISTS;'

export const ORDERS_DETAILS_REQUEST = 'ORDERS_DETAILS_REQUEST';
export const ORDERS_DETAILS_RECEIVE = 'ORDERS_DETAILS_RECEIVE';
export const ORDERS_DETAILS_INVALIDATE = 'ORDERS_DETAILS_INVALIDATE';
export const ORDERS_DETAILS_NA_ERROR = 'ORDERS_DETAILS_NA_ERROR';
export const ORDERS_DETAILS_ERROR = 'ORDERS_DETAILS_ERROR';

export const ORDERS_SET_FAVORITE_REQUEST = 'ORDERS_SET_FAVORITE_REQUEST';
export const ORDERS_SET_FAVORITE_RECEIVE = 'ORDERS_SET_FAVORITE_RECEIVE';
export const ORDERS_SET_VIEWED_REQUEST = 'ORDERS_SET_VIEWED_REQUEST';
export const ORDERS_SET_VIEWED_RECEIVE = 'ORDERS_SET_VIEWED_RECEIVE';
export const ORDERS_SET_STATUS_REQUEST = 'ORDERS_SET_STATUS_REQUEST';
export const ORDERS_SET_STATUS_RECEIVE = 'ORDERS_SET_STATUS_RECEIVE';

export const ORDERS_SET_RESERVATION_OVER = 'ORDERS_SET_RESERVATION_OVER';

export const ORDERS_FILES_REQUEST = 'ORDERS_FILES_REQUEST';
export const ORDERS_FILES_RECEIVE = 'ORDERS_FILES_RECEIVE';
export const ORDERS_FILES_UPLOAD_REQUEST = 'ORDERS_FILES_UPLOAD_REQUEST';
export const ORDERS_FILES_UPLOAD_PROGRESS = 'ORDERS_FILES_UPLOAD_PROGRESS';
export const ORDERS_FILES_UPLOAD_COMPLETE = 'ORDERS_FILES_UPLOAD_COMPLETE';
export const ORDERS_FILES_UPLOAD_RECEIVE = 'ORDERS_FILES_UPLOAD_RECEIVE';
export const ORDERS_FILES_UPLOAD_ERROR = 'ORDERS_FILES_UPLOAD_ERROR';
export const ORDERS_FILES_REMOVE_REQUEST = 'ORDERS_FILES_REMOVE_REQUEST';
export const ORDERS_FILES_REMOVE_RECEIVE = 'ORDERS_FILES_REMOVE_RECEIVE';

export const ORDERS_MESSAGES_REQUEST = 'ORDERS_MESSAGES_REQUEST';
export const ORDERS_MESSAGES_RECEIVE = 'ORDERS_MESSAGES_RECEIVE';
export const ORDERS_MESSAGES_SET_READ_REQUEST = 'ORDERS_MESSAGES_SET_READ_REQUEST';
export const ORDERS_MESSAGES_SET_READ_RECEIVE = 'ORDERS_MESSAGES_SET_READ_RECEIVE';
export const ORDERS_MESSAGES_ADD_REQUEST = 'ORDERS_MESSAGES_ADD_REQUEST';
export const ORDERS_MESSAGES_ADD_RECEIVE = 'ORDERS_MESSAGES_ADD_RECEIVE';

export const ORDERS_MESSAGES_ADD_ATTACH_RECEIVE = 'ORDERS_MESSAGES_ADD_ATTACH_RECEIVE';

export const ORDERS_REPORT_REQUEST = 'ORDERS_REPORT_REQUEST';
export const ORDERS_REPORT_RECEIVE = 'ORDERS_REPORT_RECEIVE';

export const SET_ORDERS_QAREPORT_REQUEST = 'SET_ORDERS_QAREPORT_REQUEST';
export const SET_ORDERS_QAREPORT_RECEIVE = 'SET_ORDERS_QAREPORT_RECEIVE';

export const STATUS_OPEN = 'open';
export const STATUS_PROGRESS = 'progress';
export const STATUS_COMPLETE = 'complete';
export const STATUS_DELETED = 'deleted';

export const ordersAddList = items => ({
    type: ORDERS_ADD_LIST,
    items
});

export const ordersHideInLists = number => ({
    type: ORDERS_HIDE_IN_LISTS,
    number
});

export const ordersDetailsInvalidate = number => ({
    type: ORDERS_DETAILS_INVALIDATE,
    number
});

const ordersDetailsRequest = number => ({
    type: ORDERS_DETAILS_REQUEST,
    number
});

export const ordersDetailsReceive = (number, details) => ({
    type: ORDERS_DETAILS_RECEIVE,
    number,
    details
});

const orderDetailsNaError = number => ({
    type: ORDERS_DETAILS_NA_ERROR,
    number
});

const orderDetailsError = number => ({
    type: ORDERS_DETAILS_ERROR,
    number
});

const ordersDetailsFetch = number => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersDetailsRequest(number));
        return authFetch(`${urls.orders}/${id}`).then(json => dispatch(ordersDetailsReceive(number, json))).catch(error => {
            if (error.status === 405 || error.status === 422) {
                dispatch(orderDetailsNaError(number));
                return;
            }
            dispatch(orderDetailsError(number));
        });
    };
};

const ordersDetailsShouldFetch = (number, state) => {
    const order = state.orders[number];
    if (order.isFetching) {
        return false;
    } else {
        return order.didInvalidate;
    }
};

export const ordersDetailsFetchIfNeeded = number => {
    return (dispatch, getState) => {
        if (ordersDetailsShouldFetch(number, getState())) {
            return dispatch(ordersDetailsFetch(number));
        }
    };
};

const ordersSetFavoriteRequest = number => {
    return {
        type: ORDERS_SET_FAVORITE_REQUEST,
        number
    }
};

const ordersSetFavoriteReceive = (number, value) => {
    return {
        type: ORDERS_SET_FAVORITE_RECEIVE,
        number,
        value
    }
};

export const ordersSetFavoriteFetch = (number, value) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersSetFavoriteRequest(number));
        return authFetch(`${urls.orders}/${id}`, {
            method: 'POST',
            body: JSON.stringify({ action: value ? 'favorite_set' : 'favorite_unset' })
        }).then(json => dispatch(ordersSetFavoriteReceive(number, value)));
    };
};

const ordersSetViewedRequest = number => {
    return {
        type: ORDERS_SET_VIEWED_REQUEST,
        number
    }
};

const ordersSetViewedReceive = number => {
    return {
        type: ORDERS_SET_VIEWED_RECEIVE,
        number
    }
};

const ordersSetViewedFetch = number => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersSetViewedRequest(number));
        return authFetch(`${urls.orders}/${id}`, {
            method: 'POST',
            body: JSON.stringify({ action: 'view' })
        }).then(() => dispatch(ordersSetViewedReceive(number)));
    };
};

const ordersSetViewedShouldFetch = (number, state) => {
    const order = state.orders[number];
    if (order.isFetchingViewed) {
        return false;
    }
    return !order.is_viewed;
};

export const ordersSetViewedFetchIfNeeded = number => {
    return (dispatch, getState) => {
        if (ordersSetViewedShouldFetch(number, getState())) {
            return dispatch(ordersSetViewedFetch(number));
        }
    };
};


const ordersSetStatusRequest = number => {
    return {
        type: ORDERS_SET_STATUS_REQUEST,
        number
    };
};

const ordersSetStatusReceive = (number, details) => {
    return {
        type: ORDERS_SET_STATUS_RECEIVE,
        number,
        details
    };
};

const ordersSetStatusFetch = (number, value) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersSetStatusRequest(number));
        return authFetch(`${urls.orders}/${id}`, {
            method: 'POST',
            body: JSON.stringify({ action: value })
        }).then(json => dispatch(ordersSetStatusReceive(number, json))).catch(error => {
            if (error.status === 405 || error.status === 422) {
                dispatch(orderDetailsNaError(number));
                return;
            }
            dispatch(orderDetailsError(number));
        });
    };
};

export const ordersSetStatusAcceptedFetch = number => ordersSetStatusFetch(number, 'accept');
export const ordersSetStatusCompletedFetch = number => ordersSetStatusFetch(number, 'complete_grading');

export const ordersSetReservationOver = number => ({
    type: ORDERS_SET_RESERVATION_OVER,
    number
});

// Order files
const ordersFilesRequest = number => {
    return {
        type: ORDERS_FILES_REQUEST,
        number
    };
};

const ordersFilesReceive = (number, files) => {
    return {
        type: ORDERS_FILES_RECEIVE,
        number,
        files
    };
};

const ordersFilesFetch = number => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersFilesRequest(number));
        return authFetch(`${urls.orders}/${id}/files`).then(json => {
            const files = json.results.reduce((result, item) => {
                result[item._id] = item;
                return result;
            }, {});
            dispatch(ordersFilesReceive(number, files))
        }).catch(() => dispatch(orderDetailsError(number)));
    };
};

const ordersFilesShouldFetch = (number, state) => {
    const order = state.orders[number];
    if (!order.files) {
        return true;
    }
    if (order.files.isFetching) {
        return false;
    }
    return order.files.didInvalidate;
};

export const ordersFilesFetchIfNeeded = number => {
    return (dispatch, getState) => {
        if (ordersFilesShouldFetch(number, getState())) {
            return dispatch(ordersFilesFetch(number));
        }
    };
};

const ordersFilesUploadRequest = (number, fileId, fileName, group, abort) => ({
    type: ORDERS_FILES_UPLOAD_REQUEST,
    number,
    fileId,
    fileName,
    group,
    abort
});

const ordersFilesUploadProgress = (number, fileId, progress) => ({
    type: ORDERS_FILES_UPLOAD_PROGRESS,
    number,
    fileId,
    progress
});

const ordersFilesUploadComplete = (number, fileId) => ({
    type: ORDERS_FILES_UPLOAD_COMPLETE,
    number,
    fileId
});

const ordersFilesUploadReceive = (number, fileId, data) => ({
    type: ORDERS_FILES_UPLOAD_RECEIVE,
    number,
    fileId,
    data
});

const ordersFilesUploadError = (number, fileId) => ({
    type: ORDERS_FILES_UPLOAD_ERROR,
    number,
    fileId,
});

export const orderFilesUploadFetch = (number, file, group, fileId) => {
    return (dispatch, getState) => {
        fileId = fileId || `molab/wt/${number}/${shortid.generate()}/${file.name}`;
        const xhr = new XMLHttpRequest();
        dispatch(ordersFilesUploadRequest(number, fileId, file.name, group, () => xhr.abort()));
        return uploadFetchAmazon(fileId, file, (percent) => dispatch(ordersFilesUploadProgress(number, fileId, percent)), xhr).then(fileUrl => {
            dispatch(ordersFilesUploadComplete(number, fileId));
            const id = getState().orders[number]._id;
            if (!id) {
                alert('id not found');
                return;
            }
            let type;

            switch (group) {
                case 'message':
                    type = 'msgs';
                    break;
                case 'file_pregrader_comment':
                    type = 'file_pregrader_comment';
                    break;
                default:
                    type = 'final_draft';
                    break;
            }

            return authFetch(`${urls.orders}/${id}/files`, {
                method: 'POST',
                body: JSON.stringify({
                    file: file.name,
                    location: fileUrl,
                    size: file.size,
                    type
                })
            });
        }).then(json => {
            dispatch(ordersFilesUploadReceive(number, fileId, json));
        }).catch(() => {
            dispatch(ordersFilesUploadError(number, fileId));
        });
    };
};

const ordersFilesRemoveRequest = (number, fileId) => ({
    type: ORDERS_FILES_REMOVE_REQUEST,
    number,
    fileId
});

const ordersFilesRemoveReceive = (number, fileId) => ({
    type: ORDERS_FILES_REMOVE_RECEIVE,
    number,
    fileId
});

export const ordersFilesRemoveFetch = (number, fileId) => {
    return (dispatch, getState) => {
        const order = getState().orders[number];
        const id = order._id;
        if (!id) {
            alert('id not found');
            return;
        }
        const file = order.files.items[fileId];
        if (file.isUploading) {
            file.abort();
            dispatch(ordersFilesRemoveReceive(number, fileId));
            return;
        }
        dispatch(ordersFilesRemoveRequest(number, fileId));
        return authFetch(`${urls.orders}/${id}/files/${fileId}`, {
            method: 'POST',
            body: JSON.stringify({ action: 'remove' })
        }).then(() => dispatch(ordersFilesRemoveReceive(number, fileId)));
    };
};

// Messages
const ordersMessagesRequest = number => ({
    type: ORDERS_MESSAGES_REQUEST,
    number
});

const ordersMessagesReceive = (number, messages) => ({
    type: ORDERS_MESSAGES_RECEIVE,
    number,
    messages
});

export const ordersMessagesFetch = number => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersMessagesRequest(number));
        return authFetch(`${urls.orders}/${id}/messages`).then(json => {
            const messages = json.results.reduce((result, item) => {
                result[item._id] = item;
                return result;
            }, {});
            dispatch(ordersMessagesReceive(number, messages));
        }).catch(error => {
            if (error.status === 405 || error.status === 422) {
                dispatch(orderDetailsNaError(number));
                return;
            }
            dispatch(orderDetailsError(number));
        });
    };
};

const ordersMessagesShouldFetch = (number, state) => {
    const order = state.orders[number];
    if (!order.messages) {
        return true;
    }
    if (order.messages.isFetching) {
        return false;
    }
    return order.messages.didInvalidate;
};

export const ordersMessagesFetchIfNeeded = number => {
    return (dispatch, getState) => {
        if (ordersMessagesShouldFetch(number, getState())) {
            return dispatch(ordersMessagesFetch(number));
        }
    };
};

const ordersMessagesSetReadRequest = (number, messageId) => ({
    type: ORDERS_MESSAGES_SET_READ_REQUEST,
    number,
    messageId
});

const ordersMessagesSetReadReceive = (number, messageId, message) => ({
    type: ORDERS_MESSAGES_SET_READ_RECEIVE,
    number,
    messageId,
    message
});

export const ordersMessagesSetReadFetch = (number, messageId) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersMessagesSetReadRequest(number, messageId));
        return authFetch(`${urls.orders}/${id}/messages/${messageId}`, {
            method: 'PATCH',
            body: JSON.stringify({ status: 'read_confirm' })
        }).then(data => {
            dispatch(ordersMessagesSetReadReceive(number, messageId, data));
            dispatch(notificationSetMessageRead(messageId));
        }).catch(() => dispatch(orderDetailsError(number)));
    };
};

const ordersMessagesAddRequest = number => ({
    type: ORDERS_MESSAGES_ADD_REQUEST,
    number
});

const ordersMessagesAddReceive = (number, message) => ({
    type: ORDERS_MESSAGES_ADD_RECEIVE,
    number,
    message
});

export const ordersMessagesAddFetch = (number, to, message, attachment) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersMessagesAddRequest(number));
        return authFetch(`${urls.orders}/${id}/messages`, {
            method: 'POST',
            body: JSON.stringify({ message, to_user: to, attachment })
        }).then(data => dispatch(ordersMessagesAddReceive(number, data))).catch(() => dispatch(orderDetailsError(number)));
    };
};

export const ordersMessagesAddAttachFetch = (number, to, files, message) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersMessagesAddRequest(number));
        const fileFetchList = files.map(file => authFetch(`${urls.orders}/${id}/files`, {
            method: 'POST',
            body: JSON.stringify({
                file: file.name,
                location: file.id,
                size: file.size,
                type: 'msgs',
            })
        }));
        return Promise.all(fileFetchList).then(uploadedFiles => {
            uploadedFiles.forEach(item => dispatch(ordersFilesUploadReceive(number, item.location, item)));
            const attachment = uploadedFiles.map(item => item._id);
            return dispatch(ordersMessagesAddFetch(number, to, message, attachment));
        });
    }
};

const ordersReportRequest = number => ({
    type: ORDERS_REPORT_REQUEST,
    number
});

const ordersReportReceive = number => ({
    type: ORDERS_REPORT_RECEIVE,
    number
});

export const ordersReportFetch = (number, report) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersReportRequest(number));
        return authFetch(`${urls.orders}/${id}`, {
            method: 'POST',
            body: JSON.stringify({ action: 'writer_report', comment: report })
        }).then(json => dispatch(ordersReportReceive(number))).catch(() => dispatch(orderDetailsError(number)));
    };
}

const ordersQAReportRequest = number => ({
    type: SET_ORDERS_QAREPORT_REQUEST,
    number
});

const ordersQAReportReceive = number => ({
    type: SET_ORDERS_QAREPORT_RECEIVE,
    number
});

export const ordersQAReportFetch = (number, report) => {
    return (dispatch, getState) => {
        const id = getState().orders[number]._id;
        if (!id) {
            alert('id not found');
            return;
        }
        dispatch(ordersQAReportRequest(number));
        return authFetch(`${urls.orders}/${id}`, {
            method: 'POST',
            body: JSON.stringify(report)
        }).then(json => dispatch(ordersQAReportReceive(number)));
    };
}


// WEBPACK FOOTER //
// ./src/store/orders/actions.js